import React from 'react'

import styles from '../../HistoricalImagery.module.scss'

function NonExistentData() {
  const handleRefresh = () => window.location.reload()
  return (
    <div className={styles.nonExistentContainer}>
      <h4 className={styles.nonExistentTitle}>Oops, sorry about that.</h4>
      <p className={styles.nonExistentContent}>
        It looks like there is no historical imagery available at this time. Try <span onClick={handleRefresh}>refreshing</span> the application. If this issue
        persists, please feel free to contact us at{' '}
        <a href='mailto:reachus@gohunt.com' rel='noreferrer' target='_blank'>
          GOHUNT.
        </a>
      </p>
    </div>
  )
}

export default NonExistentData
